import tokens from '@ifood/pomodoro-tokens';
import styled, { css } from 'styled-components';

import Link from '../Link';

export const Container = styled.div`
  display: flex;
  align-items: center;
  min-height: 34px;
  width: 100%;
`;

export const LinkStyles = css`
  font-family: ${tokens.font.family.ifood.body};
  color: ${tokens.colors.grayDarkest};
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  width: 100%;
  align-items: center;
  font-size: ${tokens.fontSizes.s};
  font-weight: 200;

  &:focus {
    color: ${tokens.colors.grayDarkest};
  }

  &:active {
    color: ${tokens.colors.primary};
  }

  &.active {
    color: ${tokens.colors.primary};
  }
`;

export const Span = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;

  &&& {
    ${LinkStyles};
  }
`;

export const LinkItem = styled(Link)`
  &&& {
    ${LinkStyles};
  }
`;
